import "./libraryItems.scss";

import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const LibraryItems = (props: ReferenciaContenido) => {
  const dataCards = props.referenciaPlantillaContenido;

  return (
    <div className="m-library__items">
      {props.tituloGeneral ? "" : <hr className="hide-on-mobile" />}
      {props.tituloGeneral ? (
        <h2 className="m-library__items-title">
          {props.tituloGeneral ? props.tituloGeneral : ""}
        </h2>
      ) : (
        ""
      )}
      <div className="m-library__items-cards__container">
        {dataCards?.map((val, i) => {
          return (
            <div
              className={`m-library__items-cards__information`}
              key={`${val.tituloDescripcion}${i}`}
            >
              <a href={val.redireccionBoton}>
                <img
                  className="m-library__items-cards__information-img"
                  src={val.imagenPrincipal[0].file.url}
                  alt={val.imagenPrincipal[0].title}
                />
                <h4 className="m-library__items-cards__information-title">
                  {val.tituloDescripcion}
                </h4>
                <p className="m-library__items-cards__information-description">
                  {documentToReactComponents(JSON.parse(val?.descripcion?.raw))}
                </p>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LibraryItems;
